<template>
  <div id="history">
    <br />
    <ul class="nav nav-pills">
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{ 'tab-selector': true, active: status.customer }"
          href="#"
          @click="selectedCustomer()"
          >รายชื่อลูกค้า</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{ 'tab-selector': true, active: status.animal }"
          href="#"
          @click="selectedAnimal()"
          >รายชื่อสัตว์</a
        >
      </li>
    </ul>
    <br />
    <div class="right">
      <button type="button" class="btn btn-success" @click="goAdd()">
        เพิ่มประวัติ
      </button>
    </div>
    <br />
    <hospital-table v-show="status.customer" />
    <animal-table v-show="status.animal" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HospitalTable from "../../components/History/HospitalTable.vue";
import AnimalTable from "../../components/History/AnimalTable.vue";
export default {
  components: { HospitalTable, AnimalTable },
  data() {
    return {};
  },
  created() {
    // this.setSpecies();
    // this.setBreeds();
    // this.setGenders();
    // this.setContactTypes();
    // this.setSpecimenType();
    // this.setTestType();
    // this.setSetTest();
    // this.setProvinces();
    this.setListCustomer();
    // this.setDirections();
  },
  computed: {
    ...mapGetters({
      status: "History/getStatus",
      getLatestCreatedId: "Hospital/getLatestCreatedId",
    }),
  },
  methods: {
    ...mapActions({
      setListCustomer: "Hospital/getAll",
      setCustomerData: "Hospital/setData",
      setAnimalData: "Animal/setData",
      changeStatus: "History/changeStatus",
      setSpecies: "Species/setAll",
      setBreeds: "Breed/setAll",
      setGenders: "Gender/setAll",
      setContactTypes: "ContactType/setAll",
      setAdding: "History/setAdding",
      setSpecimenType: "Test/setSpecimenType",
      setTestType: "Test/setTestType",
      setSetTest: "Test/setSetTest",
      resetData: "Hospital/resetData",
      setProvinces: "Address/setProvinces",
      setDirections: "Direction/setAll",
      removeCustomerId: "Hospital/removeCustomerId",
    }),
    selectedCustomer() {
      const customer = true;
      const animal = false;
      this.changeStatus({ customer, animal });
    },
    selectedAnimal() {
      const customer = false;
      const animal = true;
      this.changeStatus({ customer, animal });
    },
    async goAdd() {
      const addingCustomer = true;
      const addingAnimal = true;
      if (!this.status.animal) {
        await this.setAdding({ addingCustomer, addingAnimal });
        await this.setCustomerData(this.getLatestCreatedId);
        this.removeCustomerId();
        this.goCustomer();
      } else {
        await this.setAnimalData(null);
        await this.setCustomerData(null);
        await this.setAdding({ addingCustomer, addingAnimal });
        // this.$router.push({ name: "history-animal-adding" });
        let routeData = this.$router.resolve({ name: "history-animal-adding" });
        window.open(routeData.href, "_blank");
      }
    },
    goCustomer() {
      // this.$router.push({ name: "history-customer-adding" });
      let routeData = this.$router.resolve({ name: "history-customer-adding" });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped>
.nav-link {
  font-weight: bold;
}
#history {
  width: 95vw;
  margin: 0 auto;
}
.right {
  text-align: right;
}
</style>

<style>
.date-box {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
}
</style>
